module.exports = {
	"No notifications found.": "Geen meldingen gevonden.",
	"Notifications": "Meldingen",
	"See all notifications": "Alle meldingen bekijken",
	"Mark all as read": "Alles als gelezen markeren"
};


//////////////////
// WEBPACK FOOTER
// ./~/@99designs/globalnav/translations/nl.json
// module id = 905
// module chunks = 31